import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    EDIT, YES,
    STORAGE_AWS,
    STORAGE_GOOGLE,
    STORAGE_MICROSOFT,
} from "const"
import { hasAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
    ChangeAccountSettings,
    updateAccountSettings,
} from "client/store"
import {
    Container,
    PageContent,
    PageForm,
    FormGroup,
    Label,
    Textarea,
    DivInput,
} from "client/components"

import Google from "./google"
import Microsoft from "./microsoft"

const Drive = () => {
    const accountSettings = useSelector((state: StoreType) => state.accountSettings.settings)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeAccountSettings) => {
        dispatch(updateAccountSettings("drive", value))
    }

    const {
        imageType,
        fileType,
        defaultStorage,
    } = accountSettings.drive

    const { cloudDrivesAllowed } = packageSettings

    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
    const showCloudSettings = userData.accountId !== 1 && cloudDrivesAllowed === YES

    let storageTitle = ""
    if (defaultStorage === STORAGE_AWS) storageTitle = lang.aws
    if (defaultStorage === STORAGE_GOOGLE) storageTitle = lang.google
    if (defaultStorage === STORAGE_MICROSOFT) storageTitle = lang.microsoftOneDrive

    return (
        <Container>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.imageType}</Label>
                                <Textarea
                                    value={imageType}
                                    onChange={(e) => onChange({ imageType: e.target.value })}
                                    readOnly={!editAccess}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.fileType}</Label>
                                <Textarea
                                    value={fileType}
                                    onChange={(e) => onChange({ fileType: e.target.value })}
                                    readOnly={!editAccess}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.defaultStorage}</Label>
                                <DivInput widePadding>{storageTitle}</DivInput>
                            </FormGroup>
                        </Col>
                    </Row>
                </PageForm>

                {
                    // allow only one drive connected
                    showCloudSettings && (
                        defaultStorage === STORAGE_AWS
                        || defaultStorage === STORAGE_GOOGLE
                    )
                    && <Google />
                }
                {
                    showCloudSettings && (
                        defaultStorage === STORAGE_AWS
                        || defaultStorage === STORAGE_MICROSOFT
                    )
                    && <Microsoft />
                }
            </PageContent>
        </Container>
    )
}
export default Drive
